// extracted by mini-css-extract-plugin
export default {"container":"CorrespondenceHistory_container__KTKtR","content":"CorrespondenceHistory_content__Vog6V","divider":"CorrespondenceHistory_divider__1Lcyv"};